import { styled } from '@mui/material/styles';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useCommonTranslation } from '../../../hooks/useCommonTranslation';
import ResetPasswordPageForm from '../../../components/member/auth/ResetPasswordPageForm';
import { usePortalName } from '../../../hooks/usePortalName';

const PREFIX = 'MemberResetPassword';

const classes = {
  container: `${PREFIX}-container`,
  left: `${PREFIX}-left`,
  right: `${PREFIX}-right`,
  center: `${PREFIX}-center`,
  logo: `${PREFIX}-logo`,
  formContainer: `${PREFIX}-formContainer`,
};

const portalName = usePortalName();
const heroImage = `${portalName}/auth_hero.webp`;
const logoSrc = `${portalName}/brand-logo-primary.svg`;

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100vh',
    backgroundSize: 'cover',
    backgroundImage: `url(${heroImage})`,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  [`& .${classes.left}`]: {
    flex: 1,
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'center',
    paddingLeft: theme.spacing(10),
    paddingTop: theme.spacing(30),
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(2),
      justifyContent: 'center',
    },
  },
  [`& .${classes.right}`]: {
    flex: 1,
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'center',
    paddingRight: theme.spacing(10),
    paddingTop: theme.spacing(11),
    paddingBottom: theme.spacing(3),
    overflowY: 'auto',
    [theme.breakpoints.down('md')]: {
      paddingRight: theme.spacing(2),
      justifyContent: 'center',
    },
  },
  [`& .${classes.center}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100vh',
    overflowY: 'auto',
    padding: theme.spacing(4),
    gap: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
  },
  [`& .${classes.logo}`]: {
    width: 'auto',
    height: 'auto',
    display: 'block',
    objectFit: 'contain',
    [theme.breakpoints.down('md')]: {
      maxWidth: 180,
      marginBottom: theme.spacing(4),
      marginTop: theme.spacing(4),
    },
  },
  [`& .${classes.formContainer}`]: {
    position: 'relative',
    maxWidth: 375,
    width: '100%',
  },
}));

export default function MemberResetPassword() {
  const t = useCommonTranslation();
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Root className={classes.container}>
      {isLarge && (
        <Box className={classes.left}>
          <img
            alt={`${t('member.logoAlt')}`}
            src={logoSrc}
            className={classes.logo}
          />
        </Box>
      )}
      {isLarge && (
        <Box className={classes.right}>
          <Box className={classes.formContainer}>
            <ResetPasswordPageForm />
          </Box>
        </Box>
      )}
      {!isLarge && (
        <Box className={classes.center}>
          <img
            alt={`${t('member.logoAlt')}`}
            src={logoSrc}
            className={classes.logo}
          />
          <Box className={classes.formContainer}>
            <ResetPasswordPageForm />
          </Box>
        </Box>
      )}
    </Root>
  );
}
